<template>
  <div>
    <div class="columns row-table-headings">
      <div class="column column-no">{{ index + 1 }}.</div>
      <div class="column column-criteria-title">
        <CriteriaViewUpdateComponent
          :class="$style.criteriaTitleContainer"
          :criteria="criteriaOption.criteria"
        />
        <b-collapse
          v-if="criteriaOption.criteria.guide !== ''"
          :open="false"
          aria-id="contentIdForA11y1"
        >
          <template #trigger="props">
            <div class="guide-btn-container">
              <b-button
                :label="!props.open ? 'Show Guide' : 'Hide Guide'"
                class="guide-trigger-btn"
                aria-controls="contentIdForA11y1"
              />
              <b-icon
                :icon="!props.open ? 'chevron-down' : 'chevron-up'"
                size="is-medium"
              >
              </b-icon>
            </div>
          </template>
          <div :class="$style.guideSection">
            <div class="content">
              {{ criteriaOption.criteria.guide }}
            </div>
          </div>
        </b-collapse>
      </div>
    </div>
    <div class="columns row-table-content">
      <div class="column column-empty"></div>
      <div class="column column-table-data">
        <div :class="[$style.rangeValueContainer]">
          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th :class="$style.answerChoicesHeaderStyle">Answer Choices</th>
                <th :class="$style.answerTotalHeaderStyle">Answer</th>
                <th :class="$style.answerTotalHeaderStyle">
                  Total To-Date
                  <b-tooltip
                    v-if="totalToDateMessage"
                    label="Includes the value currently being edited"
                    position="is-bottom"
                    :class="$style.infoTooltip"
                  >
                    <b-icon
                      icon="information-outline"
                      size="is-small"
                      custom-size="mdi-15px"
                      :custom-class="$style.infoIcon"
                    >
                    </b-icon>
                  </b-tooltip>
                </th>
                <th :class="$style.countHeaderStyle">Count</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td :class="$style.sliderBodyStyle">
                  <section>
                    <b-field>
                      <b-numberinput
                        v-model="sliderValue"
                        type="number"
                        :controls="false"
                        :class="$style.numberInput"
                        onkeydown="if(event.key==='.'){event.preventDefault();}"
                      ></b-numberinput>
                      <span :class="$style.rangeValue"
                        ><span style="font-weight: bold">Min:</span>
                        {{ minValue }},
                        <span style="font-weight: bold">Max:</span>
                        {{ maxValue }}</span
                      >
                    </b-field>
                    <p
                      v-if="showRangeErrorMessage"
                      :class="$style.validationErrorMessage"
                    >
                      Value must be between {{ minValue }} to {{ maxValue }}
                    </p>
                    <br />
                    <br />
                    <b-field style="padding: 0px 13px">
                      <Slider
                        v-model="sliderValue"
                        :max="maxValue"
                        :min="minValue"
                      />
                    </b-field>
                  </section>
                </td>
                <td colspan="3" :class="$style.answerBodyStyle">
                  <div
                    :class="[
                      answerValueDetail.length > 8
                        ? $style.scrollableColumn
                        : answerValueDetail.length > 1
                        ? $style.nonScrollableColumn
                        : $style.singleNAColumn,
                      $style.answerValueContainer,
                    ]"
                  >
                    <table class="table is-fullwidth" style="height: 100%">
                      <tbody>
                        <tr
                          v-for="(item, itemIndex) in answerValueDetail"
                          :key="itemIndex"
                        >
                          <td :class="$style.answerTotalTableStyle">
                            {{ item.option }}
                          </td>
                          <td :class="$style.answerTotalTableStyle">
                            {{ item.totalToDate }}
                          </td>
                          <td :class="$style.countTableStyle">
                            <div
                              class="columns"
                              :class="$style.countTableDivStyle"
                            >
                              <b-field>
                                <b-input
                                  :class="$style.numberInput"
                                  type="number"
                                  v-model="item.value"
                                  onkeydown="javascript: return event.keyCode === 8 || event.keyCode === 46 ? true : !isNaN(Number(event.key))"
                                  @input="updateRangeValue(item, itemIndex)"
                                  maxlength="7"
                                  min="0"
                                ></b-input>
                              </b-field>
                              <div :class="$style.plusIconColumn">
                                <a
                                  @click="
                                    handleRemoveRangeValue(item, itemIndex)
                                  "
                                >
                                  <b-icon
                                    v-if="
                                      itemIndex !== answerValueDetail.length - 1
                                    "
                                    type="is-black"
                                    icon="close"
                                    size="is-small"
                                  ></b-icon>
                                </a>
                              </div>
                            </div>
                            <div
                              v-for="(val, index) in validateValueError"
                              :key="index"
                            >
                              <p
                                v-if="
                                  val.option === item.option && val.hasError
                                "
                                :class="$style.validationErrorMessage"
                              >
                                Value must not be empty
                              </p>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
              <tr>
                <td :class="$style.answerChoicesBottomStyle"></td>
                <td :class="$style.answerTotalBottomStyle">
                  {{ sliderValue }}
                </td>
                <td :class="$style.answerTotalBottomStyle">
                  {{ totalToDateValue }}
                </td>
                <td :class="$style.countBottomStyle">
                  <div class="columns" :class="$style.countBottomDivStyle">
                    <b-field>
                      <b-input
                        :class="$style.numberInput"
                        type="number"
                        v-model="countValue"
                        onkeydown="javascript: return event.keyCode === 8 || event.keyCode === 46 ? true : !isNaN(Number(event.key))"
                        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                        maxlength="7"
                        min="0"
                      ></b-input>
                    </b-field>
                    <div :class="$style.plusIconColumn">
                      <img
                        v-if="showCountErrorMessage || showRangeErrorMessage"
                        src="~@/assets/icons/add_circle-disabled.png"
                        :class="$style.disablePlusIcon"
                      />
                      <a v-else @click="handleAddCountValue(countValue)">
                        <img
                          src="~@/assets/icons/ic_submitrecord.png"
                          :class="$style.plusIcon"
                        />
                      </a>
                    </div>
                  </div>
                  <p
                    v-if="showCountErrorMessage"
                    :class="$style.validationCountErrorMessage"
                  >
                    Value must not be empty
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div
      class="columns row-table-comment"
      v-if="
        !criteriaOption.isCommentSectionExpanded &&
        resultData.criteriaData.length > 1
      "
    >
      <div class="column column-empty-comment"></div>
      <div
        class="column column-data-comment"
        @click="showCommentBox(criteriaOption)"
      >
        + Add Comment
      </div>
    </div>
    <div
      class="columns row-table-comment"
      v-if="
        criteriaOption.isCommentSectionExpanded ||
        resultData.criteriaData.length === 1
      "
    >
      <div class="column column-empty-comment"></div>
      <div class="column column-data-comment-box">
        <b-field label="Comment">
          <b-input v-model="criteriaOption.comments" type="textarea"> </b-input>
        </b-field>
      </div>
    </div>
    <div></div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { cloneDeep as _cloneDeep } from 'lodash';
import {
  DataCollectionSubmitRequestPayload,
  DataCollectionSummaryCriteria,
  RangeOptionValueType,
  DataCollectionCriteriaDataPayload,
  RangeErrorValidation,
} from '@/store/modules/audits/types/audits.types';
import Slider from '@vueform/slider/dist/slider.vue2.js';
import CriteriaViewUpdateComponent from '../../Project/components/CriteriaViewUpdateComponent.vue';

@Component({
  components: {
    Slider,
    CriteriaViewUpdateComponent,
  },
})
export default class DataCollectionRangeCriteria extends Vue {
  @Prop()
  public index!: number;

  @Prop()
  public criteriaOption!: DataCollectionCriteriaDataPayload;

  @Prop()
  public totalToDateMessage!: boolean;

  @Prop()
  public resultData!: DataCollectionSubmitRequestPayload;

  @Prop()
  public editDataCollectionRecord!: any;

  @Prop()
  public criteriaSamplingData!: any;

  public sliderValue: number = 0;
  public countValue: number = 0;
  public showRangeErrorMessage: boolean = false;
  public showCountErrorMessage: boolean = false;
  public showValueErrorMessage: boolean = false;
  public answerValueDetail: RangeOptionValueType[] = [];
  public removedAnswerValueDetail: RangeOptionValueType[] = [];
  public validateValueError: RangeErrorValidation[] = [];

  public mounted() {
    this.answerValueDetail = this.criteriaOption.optionValues;
    const indexOfExistingNA = this.answerValueDetail
      .map((optionValue) => optionValue.option)
      .indexOf('N/A');

    const naOptionValue: RangeOptionValueType | undefined = {
      option: 'N/A',
      totalToDate:
        indexOfExistingNA >= 0
          ? this.answerValueDetail[indexOfExistingNA].totalToDate
          : 0,
      value:
        indexOfExistingNA >= 0
          ? this.answerValueDetail[indexOfExistingNA].value
          : 0,
    };

    if (indexOfExistingNA >= 0) {
      this.answerValueDetail.splice(indexOfExistingNA, 1);
    }
    this.answerValueDetail.push(naOptionValue as RangeOptionValueType); // to ensure NA option is always the last item
    this.sliderValue = this.minValue;
    this.answerValueDetail.forEach((data: RangeOptionValueType) => {
      this.validateValueError.push({
        option: data.option,
        hasError: false,
      });
    });
    this.$emit('valuePopulated');
  }

  get totalToDateValue(): number {
    const existingOptionValue = this.criteriaOption.optionValues.find(
      (data: RangeOptionValueType) => Number(data.option) === this.sliderValue,
    );
    let existingTotalToDateValue = this.removedAnswerValueDetail.find(
      (data: RangeOptionValueType) => {
        if (Number(data.option) === this.sliderValue) {
          return data;
        }
      },
    );

    if (this.editDataCollectionRecord && this.criteriaSamplingData) {
      if (!existingTotalToDateValue) {
        existingTotalToDateValue = this.criteriaSamplingData.find(
          (data: RangeOptionValueType) => {
            if (Number(data.option) === this.sliderValue) {
              return data;
            }
          },
        );
      }
    }

    if (existingOptionValue) {
      return existingOptionValue.totalToDate;
    } else if (existingTotalToDateValue) {
      return existingTotalToDateValue.totalToDate;
    } else {
      return 0;
    }
  }

  get minValue(): number {
    return parseInt(
      JSON.parse(this.criteriaOption.criteria.criteriaOptions)[0],
      10,
    );
  }

  get maxValue(): number {
    return parseInt(
      JSON.parse(this.criteriaOption.criteria.criteriaOptions)[1],
      10,
    );
  }

  public showCommentBox(rowData: DataCollectionCriteriaDataPayload) {
    rowData.isCommentSectionExpanded = !rowData.isCommentSectionExpanded;
  }

  public handleAddCountValue(value: number | string) {
    let optionIndex = 0;
    const existingOptionValue = this.answerValueDetail.find(
      (data: RangeOptionValueType, index: number) => {
        if (Number(data.option) === this.sliderValue) {
          optionIndex = index;
          return data;
        }
      },
    );

    const existingTotalToDateValue = this.removedAnswerValueDetail.find(
      (data: RangeOptionValueType) => {
        if (Number(data.option) === this.sliderValue) {
          return data;
        }
      },
    );

    if (existingOptionValue) {
      this.answerValueDetail[optionIndex].value =
        Number(existingOptionValue.value) + Number(value);
    } else {
      this.answerValueDetail.unshift({
        option: this.sliderValue,
        totalToDate: existingTotalToDateValue
          ? existingTotalToDateValue.totalToDate
          : this.totalToDateValue,
        value: Number(value),
      });
    }

    this.countValue = 0;

    this.resultData.criteriaData.forEach(
      (data: DataCollectionCriteriaDataPayload) => {
        if (data.criteria.id === this.criteriaOption.criteria.id) {
          data.optionValues = this.answerValueDetail;
        }
      },
    );
  }

  public handleRemoveRangeValue(
    item: RangeOptionValueType,
    rangeIndex: number,
  ) {
    this.removedAnswerValueDetail.push(this.answerValueDetail[rangeIndex]);
    this.answerValueDetail.splice(rangeIndex, 1);

    this.validateValueError.find((element: RangeErrorValidation) => {
      if (element.option === item.option) {
        element.hasError = false;
      }
    });

    this.resultData.criteriaData.forEach(
      (data: DataCollectionCriteriaDataPayload) => {
        if (data.criteria.id === this.criteriaOption.criteria.id) {
          data.optionValues = this.answerValueDetail;
        }
      },
    );
  }

  public updateRangeValue(data: RangeOptionValueType) {
    this.showValueErrorMessage = data.value ? false : true;

    this.validateRangeValue(data.option);

    if (!this.showValueErrorMessage) {
      this.answerValueDetail.find((item: RangeOptionValueType) => {
        if (Number(item.option) === Number(data.option)) {
          return (item.value = data.value);
        }
      });
      this.resultData.criteriaData.forEach(
        (element: DataCollectionCriteriaDataPayload) => {
          if (element.criteria.id === this.criteriaOption.criteria.id) {
            element.optionValues = this.answerValueDetail;
          }
        },
      );
    }

    this.$emit('updateSubmitButton', {
      index: this.index,
      isError: this.showValueErrorMessage,
    });
  }

  public validateRangeValue(option: number | string) {
    const hasValueValidateError = this.validateValueError.find(
      (element: RangeErrorValidation) => element.option === option,
    );

    if (hasValueValidateError) {
      this.validateValueError.find((element: RangeErrorValidation) => {
        if (element.option === hasValueValidateError.option) {
          element.hasError = this.showValueErrorMessage;
        }
      });
    } else {
      this.validateValueError.push({
        option,
        hasError: this.showValueErrorMessage,
      });
    }
  }

  @Watch('sliderValue')
  public watchSliderValue(newValue: number) {
    this.showRangeErrorMessage =
      newValue < this.minValue || newValue > this.maxValue || newValue === null
        ? true
        : false;

    this.$emit('updateSubmitButton', {
      index: this.index,
      isError: this.showRangeErrorMessage,
    });
  }

  @Watch('countValue')
  public watchCountValue(newValue: number) {
    this.showCountErrorMessage = newValue || newValue === 0 ? false : true;
    if (!this.showRangeErrorMessage) {
      this.$emit('updateSubmitButton', {
        index: this.index,
        isError: this.showCountErrorMessage,
      });
    }
  }
}
</script>
<style src="@vueform/slider/themes/default.css"></style>
<style lang="scss" module>
.bField .label {
  color: #9f9f9f;
  font-size: 14px;
}
.numberInput {
  width: 80px !important;
  height: 44px;
  input {
    background-color: white !important;
    border-color: #dfdfdf !important;
    color: #444f51 !important;
    text-align: right;
    height: 44px;
    padding: 7px 7px;
  }
}
input[type='number'] {
  -moz-appearance: textfield;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.criteriaTitleContainer {
  margin-bottom: 8px;
}
.guideSection {
  color: #9f9f9f;
  font-size: 14px;
  margin-top: 8px;
}
.answerChoicesHeaderStyle {
  width: 60% !important;
  border-right: 1px solid #dfdfdf !important;
}
.answerTotalHeaderStyle {
  width: 13% !important;
  text-align: center !important;
  border-right: 1px solid #dfdfdf !important;
}
.countHeaderStyle {
  width: 14% !important;
  text-align: center !important;
}
.sliderBodyStyle {
  border-right: 1px solid #dfdfdf !important;
  padding-right: 10px !important;
  height: 100px !important;
}
.answerBodyStyle {
  padding: 0px !important;
  height: 0 !important;
}
.answerTotalTableStyle {
  width: 28.7% !important;
  border-right: 1px solid #dfdfdf !important;
  text-align: right !important;
  padding-top: 25px !important;
  padding-right: 10px !important;
  padding-bottom: 15px !important;
  color: #9f9f9f !important;
}
.countTableStyle {
  width: 31% !important;
  padding-bottom: 15px !important;
}
.countTableDivStyle {
  font-weight: 300px;
  padding-top: 25px;
  padding-left: 30px;
}
.answerChoicesBottomStyle {
  border-right: 1px solid #dfdfdf !important;
}
.answerTotalBottomStyle {
  border-right: 1px solid #dfdfdf !important;
  border-top: 1px solid #dfdfdf !important;
  text-align: right !important;
  padding-top: 25px !important;
  padding-right: 10px !important;
  color: #9f9f9f !important;
}
.countBottomStyle {
  border-top: 1px solid #dfdfdf !important;
  padding-bottom: 10px !important;
}
.countBottomDivStyle {
  padding-left: 18px;
  padding-top: 20px;
}
.validationErrorMessage {
  color: red;
  font-size: 12px;
  margin-top: 4px;
  margin-left: 10px;
}
.validationCountErrorMessage {
  color: red;
  font-size: 12px;
  margin-top: 4px;
}
.plusIcon {
  color: #21b5ea;
  width: 16px;
  height: 16px;
}
.disablePlusIcon {
  color: #21b5ea;
  width: 22px;
  height: 22px;
}
.plusIconColumn {
  padding-left: 20px;
  padding-top: 15px;
}
.scrollableColumn {
  overflow-y: scroll;
  height: 570px;
  overflow-x: hidden;
}
.nonScrollableColumn {
  height: auto;
}
.singleNAColumn {
  height: 120px;
}
.rangeValue {
  padding-top: 10px;
  padding-left: 20px;
  color: #b4b3b3;
  font-size: 14px;
}
.infoTooltip {
  position: absolute !important;
  display: inline-block !important;
}
.infoIcon {
  color: #21b5ea;
  margin-left: 8px !important;
}
.rangeValueContainer {
  border: 1px solid #dfdfdf;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  overflow: hidden;
  & > table {
    thead {
      background-color: #ffffff;
      border-bottom: 1px solid #dfdfdf;
      tr {
        font-size: 14px;
        th {
          color: #9f9f9f;
          font-weight: initial !important;
          padding: 13px 12px 13px 18px;
        }
        th:first-child {
          padding-left: 20px;
        }
      }
    }
    tbody {
      background-color: #ffffff;
      tr {
        td {
          color: #444f51;
          border: 0px;
        }
      }
    }
  }
}
.answerValueContainer {
  & > table {
    tbody {
      background-color: #ffffff;
      tr {
        td {
          color: #444f51;
          border: 0px;
          padding: 0px;
        }
      }
    }
  }
}
:root {
  --slider-connect-bg: #21b5ea;
  --slider-tooltip-bg: #21b5ea;
}
</style>
